module.exports = __webpack_public_path__ + "img/img-banner-member.7476554f.png";